import React from 'react';
import { X, FileText } from 'lucide-react';

const AllUrlsModal = ({ urls, onClose, onUrlSelect }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white max-w-4xl max-h-[80vh] w-full mx-4 overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg text-gray-900">
            All Source URLs ({urls.length})
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="p-4 overflow-y-auto max-h-[60vh]">
          <div className="space-y-3">
            {urls.map((url, idx) => {
              // const urlString = typeof url === "string" ? url : url.url;
              const urlTitle = typeof url === "string" ? url : url.title || url.url;
              
              // Extract just the filename (last part after final slash)
              const filename = urlTitle.split('/').pop();
              
              return (
                <div
                  key={idx}
                  className="p-3 bg-gray-50 border border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors"
                  onClick={() => onUrlSelect(idx)}
                >
                  <div className="flex items-start gap-3">
                    <FileText size={16} className="text-gray-500 mt-1 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-black hover:underline break-words text-left">
                        {filename}
                      </p>
                      {url.document_type && (
                        <span className="inline-block text-xs text-gray-500 bg-gray-200 px-2 py-1 rounded mt-1">
                          {url.document_type}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllUrlsModal;